import { Component, OnInit } from '@angular/core';
import { StorageManagerService } from '../../shared/services/index';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion/base-accordion.component';

@Component({
    selector: 'app-submission-device-substance-warnings-us',
    templateUrl: './submission-device-substance-warnings-us.component.html',
    styleUrls: ['./submission-device-substance-warnings-us.component.css'],
    standalone: false
})
export class SubmissionDeviceSubstanceWarningsUsComponent extends BaseAccordionComponent implements OnInit {

  constructor (public fb: FormBuilder, public storage: StorageManagerService) {

    super(fb, storage);
   }

  ngOnInit() {

    this.dataScope = this.storage.read('dataScope');

    this.initializeMainForm();

    this.patchForms();
  }

  initializeMainForm() {

    this.deviceForm = this.fb.group({
      containingLatex: ['', { validators: [] }],
      criticalWarningForm: this.fb.array([this.addCriticalWarningForm()]),
      CMRForm: this.fb.array([this.addCMRForm()]),
      substancesForm: this.fb.array([this.addSubstancesForm()]),
      criticalWarningAndContraindication: ['', { validators: [] }],
      containingPhthalates: ['', { validators: [] }],
      mriSafetyStatus: ['', { validators: [] }],
      labeledAsNotMadeWithNaturalRubber: ['', { validators: [] }]
    });

    // Watch changes on the entire deviceForm
    this.deviceForm.valueChanges.subscribe(data => {
      this.logValidationErrors(this.deviceForm);
  });
  }

  get criticalWarningForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('criticalWarningForm');
  }

  get CMRForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('CMRForm');
  }

  get substancesForm(): FormGroup {
    return <FormGroup>this.deviceForm.get('substancesForm');
  }

  addCriticalWarningForm(): FormGroup {

    return this.fb.group({
      warningValue: ['', { validators: [] }],
      warningCommentsArray: [this.fb.array([])]
    });
  }

  addCMRForm(): FormGroup {

    return this.fb.group({
      CMRValue: ['', { validators: [] }],
      casNumber: ['', { validators: [] }],
      ecNumber: ['', { validators: [] }],
      substanceNamesArray: [this.fb.array([])]
    });
  }

  addSubstancesForm(): FormGroup {

    return this.fb.group({
      substanceType: ['', { validators: [] }],
      innCode: ['', { validators: [] }],
      substanceNamesArray: [this.fb.array([])]
    });

  }

  patchForms() {

    this.deviceForm.patchValue({

      containingLatex: this.displayItemData('Containing Latex?'),
      criticalWarningAndContraindication: this.displayItemData('Critical Warnings and Contraindications'),
      containingPhthalates: this.displayItemData('Containing Phthalates?'),
      labeledAsNotMadeWithNaturalRubber: this.displayItemData('Not made with natural rubber latex?'),
      mriSafetyStatus: this.displayItemData('MRI Safety Status')
    });

    this.deviceForm.setControl('criticalWarningForm', this.setCriticalWarningForm());
    this.deviceForm.setControl('CMRForm', this.setCMRForm());
    this.deviceForm.setControl('substancesForm', this.setSubstancesForm());
  }


  setSubstancesForm(): FormArray {

    const formArray = new FormArray([]);

    let items: any;
    let substanceNamesArray: any;
    let lqv: any;

    items = this.displayItemData('MED Human Product Types');

  if (items && items.length > 0) {
    items.forEach((c, i) => {

      substanceNamesArray = c[(this.getMapInnerPathName('SubstanceNamesArray'))[0]];

      if (substanceNamesArray) {

          lqv = substanceNamesArray[(this.getMapInnerPathName('SubstanceNamesArray'))[1]];
      } else {

        lqv = [];
      }

      formArray.push(

        this.fb.group({

          innCode: c[(this.getMapInnerPathName('INN Code'))[0]],
          substanceType: c[(this.getMapInnerPathName('Medicinal or Medicinal Human Product Substance Type'))[0]],
          substanceNamesArray: this.addSubstanceNames(lqv)
        }));
     });
    }

    return formArray;
  }

  addSubstanceNames(lqv: any): FormArray {

      const arr = [];

      if (lqv && lqv.length > 0) {

        lqv.forEach(element => {
          arr.push(

            this.fb.group({
              value: element[(this.getMapInnerPathName('LQV Name'))[0]],
              language: element[(this.getMapInnerPathName('LQV Language'))[0]]
                })
            );
        });
      }

      return this.fb.array(arr);
    }


  setCMRForm(): FormArray {

    const formArray = new FormArray([]);

    let items: any;
    let substanceNamesArray: any;
    let lqv: any;
     items = this.displayItemData('CMR');

  if (items && items.length > 0) {
    items.forEach((c, i) => {

        substanceNamesArray = c[(this.getMapInnerPathName('CMRSubstanceNamesArray'))[0]];

      if (substanceNamesArray) {

          lqv = substanceNamesArray[(this.getMapInnerPathName('CMRSubstanceNamesArray'))[1]];
      } else {

        lqv = [];
      }

      formArray.push(

        this.fb.group({

          CMRValue: c[(this.getMapInnerPathName('CMRValue'))[0]],
          casNumber: c[(this.getMapInnerPathName('CAS Number'))[0]],
          ecNumber: c[(this.getMapInnerPathName('EC Number'))[0]],
          substanceNamesArray: this.addCMRSubstanceNames(lqv)
        }));
     });
    }

    return formArray;
  }

    addCMRSubstanceNames(lqv: any): FormArray {

      const arr = [];

      if (lqv && lqv.length > 0) {

        lqv.forEach(element => {
          arr.push(

            this.fb.group({
              value: element[(this.getMapInnerPathName('CMR LQV Value'))[0]],
              language: element[(this.getMapInnerPathName('CMR LQV Language'))[0]]
                })
            );
        });
      }

      return this.fb.array(arr);
    }

  setCriticalWarningForm(): FormArray {

    const formArray = new FormArray([]);

    let warnings: any;
    let commentsArray: any;
    let lqv: any;

    warnings = this.displayItemData('Critical Warning or Contraindication Value(s)');


  if (warnings && warnings.length > 0) {
    warnings.forEach((c, i) => {

      commentsArray = c[(this.getMapInnerPathName('Warning Comments'))[0]];

      if (commentsArray) {

        lqv = commentsArray[(this.getMapInnerPathName('Warning Comments LQV'))[0]];
      } else {

        lqv = [];
      }

      formArray.push(

        this.fb.group({

          warningValue: c[(this.getMapInnerPathName('Warning Value'))[0]],
          warningCommentsArray:  this.addWarningComments(lqv)
        }));
     });
    }

    return formArray;
    }

    addWarningComments(lqv: any): FormArray {

      const arr = [];

      if (lqv && lqv.length > 0) {

        lqv.forEach(element => {
          arr.push(

            this.fb.group({
              value: element[(this.getMapInnerPathName('Warning Comments LQV Value'))[0]],
              language: element[(this.getMapInnerPathName('Warning Comments LQV Language'))[0]]
                })
            );
        });
      }

      return this.fb.array(arr);
    }
}


